<template>
    <span>
        <router-link v-if="logLine.user" :to="'/users/' + logLine.user.id + '/edit'">
            {{ logLine.user.full_name }}
        </router-link>

        <span v-if="logLine.user">&middot;</span>

        {{ logLine.created_at | datetime }}
    </span>
</template>

<script>
    export default {
        props: {'logLine': {}}
    }
</script>
